module.exports = __webpack_public_path__ + "img/add.a330d73e.svg";